import { render, staticRenderFns } from "./ShipperOrgItemPage.vue?vue&type=template&id=29078982&"
import script from "./ShipperOrgItemPage.vue?vue&type=script&lang=js&"
export * from "./ShipperOrgItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ShipperOrgItemPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports